import { Link } from "office-ui-fabric-react"

const NotificationSettingsTooltip = () => {
    return <div>
        Set up daily and weekly summary notifications to Microsoft Teams or by email.
        Enable or disable email notifications on PPM Express actions/events.
        <br />
        Please refer to the <Link href="https://help.ppm.express/89245-getting-started-with-ppm-express/529387" target="_blank">article</Link> for more details.
    </div>
}

export default NotificationSettingsTooltip;